import { CSSProperties, ReactNode, useEffect, useMemo, useState } from 'react'
import styled from 'styled-components'

export function useLabels(
  styleconfig: { [key: string]: CSSProperties },
  format: 'html' | 'svg' = 'html'
) {
  const [styles] = useState(styleconfig)

  const Menu = useMemo(() => {
    const LabelComponent: React.FC<{
      children?: ReactNode

      [x: string]: any
    }> = ({ children, ...props }) => {
      const setKeys = Object.keys(styles).filter((key) => {
        if (['className'].includes(key)) return false
        return props[key]
      })
      const styleid: string = setKeys.length > 0 ? setKeys[0] : ''
      let { type, ...rest } = props
      delete rest[styleid]
      if (format === 'svg')
        return (
          <LabelSVG
            className={styleid ? styleid : ''}
            styles={styleid ? styles[styleid] : undefined}
            {...rest}
          >
            {children}
          </LabelSVG>
        )

      return (
        <LabelHTML styles={styleid ? styles[styleid] : undefined} {...rest}>
          {children}
        </LabelHTML>
      )
    }
    return LabelComponent
  }, [styles])

  return Menu
}

const LabelHTML = (props: {
  styles: CSSProperties | undefined
  children?: ReactNode
  className?: string | undefined
}) => {
  const { styles, className, ...rest } = props

  return (
    <span style={styles} {...rest} className={className}>
      {props.children && props.children}
    </span>
  )
}
const LabelSVG = (props: {
  styles: CSSProperties | undefined
  children?: ReactNode
  className?: string | undefined
}) => {
  const { styles, className, ...rest } = props

  return (
    <tspan style={styles} {...rest} className={className}>
      {props.children && props.children}
    </tspan>
  )
}
